module.exports = __webpack_public_path__ + "static/media/thirdInnerImg.a915babc.png";